import React from 'react';
import classNames from 'classnames';
import { CardGridProps } from 'antd/lib/card/Grid';
import { ConfigConsumer } from '../config-provider';
// export default withConfigProvider(Grid);
// export default Grid;
const Grid = ({ prefixCls, className, hoverable = true, ...props }) => (React.createElement(ConfigConsumer, null, ({ getPrefixCls }) => {
    const prefix = getPrefixCls('card', prefixCls);
    const classString = classNames(`${prefix}-grid`, className, {
        [`${prefix}-grid-hoverable`]: hoverable
    });
    return React.createElement("div", { ...props, className: classString });
}));
export default Grid;
